export const FORM_TYPE = {
  Create: "Create",
  Edit: "Edit",
  Delete: "Delete",
};
